
import CommonUtils from '@/common-utils';
import 'swiper/css/swiper.css'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class FindId extends Vue {
  findId() {
    // PC면 새창
    if(this.$isMobile == false) {
      window.open(`${CommonUtils.createStaticUrl(this, 'RealNameForm' )}?nextRouteName=FindIdResult`, "_blank", "width=762, height=800")
      return;
    } 
    
    this.$router.push({name: 'RealNameForm', params: {nextRouteName: 'FindIdResult'}})
  }
}
